

<div class="black-bg">
    <div class="max-page-width">
        <div class="search-location-container">
            <div class="search-location-form">
                <div class="searchFormbg">
                <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
                    <div class="row">
                        <div class="col-lg-11 col-md-10 pr-0">
                            <div class="row">
                                <div class="form-group col-lg-4 col-md-6 border-right">
                                    <label>{{ 'PickupLocation' | translate }}</label>
                                    <div class="input-group autocomplete-filed">
                                        <span class="input-group-prepend">
                                            <span class="input-group-text">
                                                <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
                                            </span>
                                        </span>
                                        <!--  <input placeholder="" type="text"
                                            formControlName="location" class="form-control"
                                            [ngClass]="{ 'is-invalid': submitted && f.location.errors }" /> -->


                                            <!-- <input
                                            ngx-google-places-autocomplete [options]='options' formControlName="location"
                                            class="form-control"
                                            placeholder="{{ 'EnterLocation' | translate }}"
                                            #placesRef="ngx-places" (onAddressChange)="handleAddressChange($event)"
                                            [ngClass]="{ 'is-invalid': submitted && f.location.errors }"
                                            /> -->

                                            <input

                                            class="form-control"
                                            placeholder="{{ 'EnterLocation' | translate }}"
                                            matInput
                                            (change)="onLocationInputChanged()"
                                            [value]="searchModel.FormatedLocation"
                                            id="pickupLocation"
                                            [address]="searchModel.FormatedLocation"
                                            matGoogleMapsAutocomplete
                                            requiredErrorText=""
                                            invalidErrorText=""
                                          (onAutocompleteSelected)=" onAutocompleteSelected($event)"
                                            [ngClass]="{ 'is-invalid': submitted && f.location.errors }"
                                            />
<!--
                                            <mat-google-maps-autocomplete class="form-control"
                                            [ngClass]="{ 'is-invalid': submitted && f.location.errors }"
                                            formControlName="location"
                                            placeholderText="Enter Location"
                                            appearance="outline"

                                            [address]="searchModel.FormatedLocation"
                                            requiredErrorText=""
                                            invalidErrorText=""
                                          (onAutocompleteSelected)=" onAutocompleteSelected($event)">
                                          </mat-google-maps-autocomplete> -->

                                    </div>
                                    <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                                        <div *ngIf="f.location.errors.required"></div>
                                    </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 border-right pl-3">
                                    <label>{{ 'PickupDate' | translate }}</label>
                                    <div class="row">
                                        <div class="col-6 pr-0">
                                            <div class="pick-up-date">
                                                <mat-form-field appearance="none" onload="document.getElementsByClassName()">
                                                    <mat-datepicker-toggle matPrefix [for]="PickUpDate"></mat-datepicker-toggle>
                                                    <mat-datepicker panelClass="select-calender-search" #PickUpDate></mat-datepicker>
                                                    <input readonly placeholder="" formControlName="PickUpDate" matInput  [min]="minPickUpDate" [matDatepicker]="PickUpDate" (click)="PickUpDate.open()"
                                                    (dateInput)="addEvent(1,'input', $event)" (dateChange)="addEvent(1,'change', $event)">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-6">

                                            <div class="pick-up-time">
                                                <input placeholder="{{ 'SelectTime' | translate }}" formControlName="PickUpTime" id="pickUpTimeSection"
                                                class="form-control"
                                                [ngClass]="{'is-invalid':f.PickUpTime.errors}"
                                                />
                                                <!-- <h1>{{f.PickUpTime.errors}}</h1> -->
                                            </div>


                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-lg-4 col-md-6 border-right pl-3">
                                    <label>{{ 'ReturnLocation' | translate }}</label>
                                    <div class="drop-up-location">
                                    <!-- <mat-form-field appearance="none">
                                        <mat-select  [(value)]="selectedLocation">
                                            <mat-option *ngFor="let dropUpLocation of dropUpLocations" [value]="dropUpLocation.returnAgencyID">
                                            {{dropUpLocation.agencyReturnLocationName}}
                                            </mat-option>
                                        </mat-select>
                                        </mat-form-field> -->

                                    <!-- <select #dropUpLocation [(value)]="selectedLocation" (change)="dropUpLocationChanged(dropUpLocation.value)" class="form-control select-control search-select classic" >
                                            <option
                                            *ngFor="let dropUpLocation of dropUpLocations"
                                            [selected]="dropUpLocation.returnAgencyID === selectedLocation"
                                            [value]="dropUpLocation.returnAgencyID">{{dropUpLocation.agencyReturnLocationName}}</option>
                                        </select> -->
                                        <div class="d-flex">
                                            <span class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
                                                </span>
                                            </span>
                                            <mat-form-field appearance="none" >
                                                <mat-select panelClass="select-new" [placeholder]="selectedLocation==null? searchModel.FormatedLocation : null "  #dropUpLocation class="search-section-top"  [(value)]="selectedLocation"  (selectionChange)="dropUpLocationChanged(dropUpLocation.value)">
                                                <mat-option *ngFor="let dropUpLocation of dropUpLocations"
                                                [selected]="dropUpLocation.returnAgencyID === selectedLocation"
                                                [value]="dropUpLocation.returnAgencyID">
                                                    {{dropUpLocation.agencyReturnLocationName | translate}}
                                                </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>

                                    </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 pl-3 ">
                                    <label>{{ 'ReturnDate' | translate }}</label>
                                    <div class="row">
                                        <div class="col-6 pr-0">
                                            <div class="drop-off-date">
                                                <mat-form-field appearance="none">
                                                    <mat-datepicker-toggle matPrefix [for]="dropUpDate"></mat-datepicker-toggle>
                                                    <mat-datepicker panelClass="select-calender-search" #dropUpDate></mat-datepicker>
                                                    <input readonly placeholder=" "
                                                    (dateInput)="addEvent(2,'input', $event)" (dateChange)="addEvent(2,'change', $event);dropUpDate.open()"
                                                    formControlName="dropUpDate" matInput [min]="minDropOffDate" [matDatepicker]="dropUpDate" (click)="dropUpDate.open()">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="drop-off-time">
                                                <input placeholder="{{ 'SelectTime' | translate }}" formControlName="dropUpTime" id="dropUpTimeSection"
                                                class="form-control"
                                                [ngClass]="{'is-invalid':f.dropUpTime.errors}"
                                                />
                                                <!-- <h1>{{f.dropUpTime.errors}}</h1> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1 col-md-2 p-0 text-right">
                            <button type="submit" class="btn search-btn login-btn">{{ 'FindBtn' | translate }}</button>
                            </div>
                    </div>
                </form>
                </div>
            </div>
        </div>
    </div>
</div>

  <simple-notifications></simple-notifications>
